export enum LikeParentEntityEnum {
  Tutorial = 'Tutorial',
  Post = 'Post',
  Track = 'Track',
}
